import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import LandingPage from './pages/LandingPage';
import FeedbackPage from './pages/FeedbackPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CharityPage from './pages/CharityPage';
import HowAIWorksPage from './pages/HowAIWorksPage';
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Admin routes have their own layout
  if (isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin" element={<LoginPage />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  }

  // Main website layout
  return (
    <div className="min-h-screen mesh-bg relative">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" />

      {/* Animated background blobs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="blob w-[600px] h-[600px] bg-cyclara-300/30 -top-48 -left-48" />
        <div className="blob w-[500px] h-[500px] bg-lavender-300/20 top-1/3 -right-32 animation-delay-2000" />
        <div className="blob w-[400px] h-[400px] bg-cyclara-200/25 bottom-0 left-1/3 animation-delay-4000" />
      </div>

      <Navbar />

      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/charity" element={<CharityPage />} />
          <Route path="/how-ai-works" element={<HowAIWorksPage />} />
        </Routes>
      </AnimatePresence>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
